module.exports = {
	"bible": {
		"0": {
			"BibleURL": "https://www.bible.com/bible"
		},
		"tabnumber": -1
	},
	"events": [
		{
			"RegisterURL": "https://www.google.com",
			"address": "Add Event Address",
			"date": "Add Date",
			"details": "Add Details:",
			"endDate": "2017-11-10T18:30:00+02:00",
			"eventLocation": "Add Event Location",
			"info": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
			"map_lat": "-26.111324",
			"map_lng": "28.055716",
			"map_zoom": "16",
			"notes": "Add Notes abut the Event here...",
			"photo": "https://via.placeholder.com/512x800",
			"startDate": "2017-11-10T10:20:00+02:00",
			"times": "Add Days, From 08h00 - 11h00",
			"title": "Add Event Title.."
		}
	],
	"more": {
		"about": [
			{
				"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
				"heading": "Latest News",
				"image": "https://via.placeholder.com/512x800",
				"photo": "https://via.placeholder.com/512x512",
				"title": "about us."
			}
		],
		"branches": [
			{
				"heading": "where we meet.",
				"image": "https://via.placeholder.com/512x800/000",
				"locations": [
					{
						"location": "New York",
						"map_lat": "-26.111324",
						"map_lng": "28.055716",
						"map_zoom": "16",
						"photo": "https://via.placeholder.com/512x512",
						"times": "Sundays: 09h00"
					}
				],
				"photo": "http://via.placeholder.com/512x512",
				"title": "our branches."
			}
		],
		"connect": [
			{
				"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
				"heading": "connect with us.",
				"image": "https://via.placeholder.com/512x800",
				"photo": "https://via.placeholder.com/512x512",
				"title": "connect with us."
			}
		],
		"leaders": [
			{
				"image": "https://via.placeholder.com/512x800",
				"leader": [
					{
						"branch": "Real Madrid Branch.",
						"name": "Pastor Jones",
						"photo": "https://via.placeholder.com/512x512",
						"social_icon": "logo-twitter",
						"social_link": "https://twitter.com"
					}
				],
				"title": "our leaders."
			}
		],
		"ministries": [
			{
				"image": "https://via.placeholder.com/512x800/000",
				"ministry": [
					{
						"image": "http://via.placeholder.com/592x396/000",
						"info": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
						"photo": "https://via.placeholder.com/512x512",
						"title": "Mens Ministry"
					}
				],
				"title": "our ministries."
			}
		],
		"music": [
			{
				"audio": [
					{
						"artist": "Singer 01",
						"audioURL": "https://www.buzzsprout.com/128873/574437-mychurch-demo?client_source=admin&amp;iframe=true&amp;referrer=https%3A%2F%2Fwww.buzzsprout.com%2Fadmin%2Fpodcasts%2F128873%2Fembed",
						"title": "Audio Title 01"
					}
				],
				"audio_title": "Audio",
				"image": "http://via.placeholder.com/512x800",
				"title": "inspirational music.",
				"video_title": "Videos",
				"videos": [
					{
						"artist": "Singer 01",
						"title": "Video Title 01",
						"videoURL": "https://www.youtube.com/embed/ejvo0ZC2H-Y"
					}
				]
			}
		],
		"social": [
			{
				"image": "https://via.placeholder.com/512x800/000",
				"photo": "https://via.placeholder.com/512x512",
				"platform": [
					{
						"icon": "https://via.placeholder.com/512x512/000",
						"url": "https://www.youtube.com/embed/ejvo0ZC2H-Y"
					}
				],
				"subtitle": "get social with us.",
				"title": "get social."
			}
		],
		"tithing": [
			{
				"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
				"heading": "about giving.",
				"image": "http://via.placeholder.com/512x800/000",
				"photo": "http://via.placeholder.com/512x512",
				"title": "giving."
			}
		]
	},
	"mySection": {
		"date": "08-14-2019",
		"description": "my section main description",
		"image": "https://firebasestorage.googleapis.com/v0/b/mychurchdemo-c4153.appspot.com/o/1563552605365.jpg?alt=media&token=9fb5615e-e970-46c1-91d4-c51f60ad4f45",
		"item": [
			{
				"date": "08-15-2019",
				"description": "this is my html <a href=\"https://www.tsn.ca\" target=\"_blank\">click here</a>.  This is <strong>bold</strong>\"",
				"image": "https://firebasestorage.googleapis.com/v0/b/mychurchdemo-c4153.appspot.com/o/1563552605365.jpg?alt=media&token=9fb5615e-e970-46c1-91d4-c51f60ad4f45",
				"title": "img title 01",
				"type": "image"
			},
			{
				"artist": "Artist A",
				"date": "08-14-2019",
				"description": "my video description",
				"image": "https://via.placeholder.com/512x512",
				"title": "video title 01",
				"type": "video",
				"videoURL": "https://www.youtube.com/embed/ejvo0ZC2H-Y"
			},
			{
				"artist": "Artist A",
				"date": "08-14-2019",
				"description": "my audio description",
				"image": "https://via.placeholder.com/512x512",
				"title": "audio title 01",
				"type": "audio",
				"audioURL": "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/277407189&color=%23ff5500&auto_play=false&hide_related=true&show_comments=false&show_user=false&show_reposts=false&show_teaser=false"
			},
			{
				"date": "08-14-2019",
				"description": "my pdf description",
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/mychurchdemo-c4153.appspot.com/o/sample.pdf?alt=media&token=98434d5c-a273-4341-886e-cf0170017d2f",
				"image": "https://via.placeholder.com/512x512",
				"title": "pdf title 01",
				"type": "pdf"
			},
			{
				"date": "08-14-2019",
				"description": "my section main description",
				"image": "https://firebasestorage.googleapis.com/v0/b/mychurchdemo-c4153.appspot.com/o/1563552605365.jpg?alt=media&token=9fb5615e-e970-46c1-91d4-c51f60ad4f45",
				"item": [
					{
						"date": "08-15-2019",
						"description": "this is my html <a href=\"https://www.tsn.ca\" target=\"_blank\">click here</a>.  This is <strong>bold</strong>\"",
						"image": "https://firebasestorage.googleapis.com/v0/b/mychurchdemo-c4153.appspot.com/o/1563552605365.jpg?alt=media&token=9fb5615e-e970-46c1-91d4-c51f60ad4f45",
						"title": "sub folder img title 01",
						"type": "image"
					},
					{
						"artist": "Artist A",
						"date": "08-14-2019",
						"description": "my video description",
						"image": "https://via.placeholder.com/512x512",
						"title": "sub folder video title 01",
						"type": "video",
						"videoURL": "https://www.youtube.com/embed/ejvo0ZC2H-Y"
					},
					{
						"artist": "Artist A",
						"date": "08-14-2019",
						"description": "my audio description",
						"image": "https://via.placeholder.com/512x512",
						"title": "sub folder audio title 01",
						"type": "audio",
						"audioURL": "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/277407189&color=%23ff5500&auto_play=false&hide_related=true&show_comments=false&show_user=false&show_reposts=false&show_teaser=false"
					},
					{
						"date": "08-14-2019",
						"description": "my pdf description",
						"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/mychurchdemo-c4153.appspot.com/o/sample.pdf?alt=media&token=98434d5c-a273-4341-886e-cf0170017d2f",
						"image": "https://via.placeholder.com/512x512",
						"title": "sub folder pdf title 01",
						"type": "pdf"
					}
				],
				"title": "Folder",
				"type": "folder"
			}
		],
		"title": "Folder",
		"type": "folder"
	},
	"news": [
		{
			"date": "Add Date",
			"details": "Add Details:",
			"info": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
			"photo": "https://via.placeholder.com/512x512/000",
			"shareImage": "https://via.placeholder.com/512x512",
			"shareLink": "https://www.google.com/",
			"shareMessage": "Your News Message",
			"shareSubject": "News Title",
			"social": "https://www.instagram.com/touchhdonline/",
			"title": "Add News Headline here"
		}
	],
	"sections": [
		{
			"name": "Bible",
			"section": "bible"
		},
		{
			"name": "News",
			"section": "news"
		},
		{
			"name": "Events",
			"section": "events"
		},
		{
			"name": "Sermons",
			"section": "sermons"
		},
		{
			"name": "My Section",
			"section": "my-section"
		}
	],
	"sermons": [
		{
			"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
			"details": "Series info:",
			"duration": "10 April - 10 May '17",
			"episode": [
				{
					"audioURL": "https://www.buzzsprout.com/128873/574437-mychurch-demo?client_source=admin&amp;iframe=true&amp;referrer=https%3A%2F%2Fwww.buzzsprout.com%2Fadmin%2Fpodcasts%2F128873%2Fembed",
					"date": "Add Date..",
					"image": "https://via.placeholder.com/512x512/000",
					"info": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
					"leader": "Mike Smith",
					"number": "1",
					"title": "Add Sermon Title here..",
					"videoURL": "https://www.youtube.com/embed/ejvo0ZC2H-Y"
				}
			],
			"icon1": "videocam",
			"icon2": "mic",
			"length": "Series duration: 7 weeks.",
			"photo": "https://via.placeholder.com/512x512/000",
			"title": "Taking A Leap of Faith"
		}
	],
	"translations": {
		"gb": {
			"dynamic": {
				"Account": "Account",
				"AdMob": "AdMob",
				"Add_section": "Add section",
				"App_Preview": "App Preview",
				"App_Setup": "App Setup",
				"App_Submit": "App Submit",
				"App_id": "App id",
				"App_images": "App images",
				"App_info": "App info",
				"App_name": "App name",
				"App_sections": "App sections",
				"App_settings": "App settings",
				"App_setup": "App setup",
				"Basic": "Basic",
				"Billing": "Billing",
				"Cancel": "Cancel",
				"Cancel_creating_app": "Cancel creating app",
				"Close": "Close",
				"Confirm": "Confirm",
				"Create": "Create",
				"Create_app": "Create app",
				"Current_plan": "Current plan",
				"Dashboard": "Dashboard",
				"Delete": "Delete",
				"Delete_App": "Delete App",
				"Design": "Design",
				"Full_Name": "Full Name",
				"General": "General",
				"Hello": "Hello",
				"Images": "Images",
				"Layout": "Layout",
				"List_design": "List design",
				"Loading": "Loading",
				"Login": "Login",
				"Logout": "Logout",
				"MASTER_DETAILS_VIEWS": "MASTER DETAILS VIEWS",
				"Manage": "Manage",
				"Manage_app": "Manage app",
				"My_Profile": "My Profile",
				"Navigation_bar": "Navigation bar",
				"New_app": "New app",
				"Orders": "Orders",
				"Overview": "Overview",
				"Package_id": "Package id",
				"PayPal": "PayPal",
				"Preview": "Preview",
				"Preview_your_app": "Preview your app",
				"Purchase_now": "Purchase now",
				"Push_notification": "Push Notification",
				"Reset_Password": "Reset Password",
				"SPECIFIC_VIEWS": "SPECIFIC VIEWS",
				"Save_changes": "Save changes",
				"Search_apps": "Search apps",
				"Section_name": "Section name",
				"Sections": "Sections",
				"Settings": "Settings",
				"Side": "Side",
				"Submit": "Submit",
				"Submit_app": "Submit app",
				"Submit_you_app": "Submit your app",
				"Sude_menu_colors": "Sude menu colors",
				"Switch": "Switch",
				"Tabs": "Tabs",
				"Template": "Template",
				"Translations": "Translations",
				"Use_this_layout": "Use this layout",
				"Use_this_template": "Use this template",
				"User_Info": "User Info",
				"User_profile": "User profile",
				"Users": "Users",
				"Visit": "Visit",
				"preview_app": "preview app",
				"rab_id": "rab_id",
				"required": "required"
			},
			"static": {
				"All_data_at_this_location_incuding_nested_sections_will_be_deleted": "All data at this location incuding nested sections will be deleted",
				"All_informations_are_required": "All informations are required",
				"And_preview_you_app": "And Preview Your App",
				"And_preview_your_app": "And preview your app",
				"App_name_missing": "App name missing",
				"App_package_id_missing": "App package id missing",
				"Cancel_Subscription": "Cancel Subscription",
				"Confirm_selected_and_entered_data": "Confirm selected and entered data",
				"Creat_new_Admin_project": "Create new Admin project",
				"Create_app_from_template": "Create app from template",
				"Create_new_translation": "Create new translation",
				"Delete_section": "Delete section",
				"Drag_n_Drop_them_Also_you_can_nest_them": "Drag n Drop them Also you can nest them",
				"Features": "Features",
				"Go_Back": "Go Back",
				"Icon_Splash_Logo": "Icon Splash Logo",
				"Just_add_the_section_you_like": "Just add the section you like",
				"Just_scan_the_QR_code": "Just scan the QR code",
				"Let's_make_an_app": "Let's make an app",
				"Make_translation": "Make translation",
				"Manage_translation": "Manage translation",
				"Message_body": "Message body",
				"Message_text": "Message text",
				"Message_title": "Message title",
				"Name_PackageId_AppId": "Name PackageId AppId",
				"New_Password": "New Password",
				"New_Password_Confirmation": "New Password Confirmation",
				"New_Translation": "New Translation",
				"New_admin": "New admin",
				"Our_automated_script": "Our automated script",
				"Plan_Features": "Plan Features",
				"Please_Purchase_now": "Please Purchase now",
				"Please_update_your_Item_Purchase_Code": "Please update your Item Purchase Code",
				"Please_update_your_Subscription_Plan": "Please update your Subscription Plan",
				"Please_write_delete_to_confirm_deleting_the_app": "Please write delete to confirm deleting the app",
				"Scan_the_qr_code_with_this": "Scan the qr code with this",
				"Select_Traslation_To_Start_From": "Select Traslation To Start From",
				"Select_the_app_layout": "Select the app layout",
				"Select_the_app_type": "Select the app type",
				"Send_push_notification_with": "Send push notification with",
				"Subscription": "Subscription",
				"Subscription_Options": "Subscription Options",
				"Update_Billing_Info": "Update Billing Info",
				"Use_Master_Detail_or_some_specific_one": "Use Master Detail or some specific one",
				"What_kind_of_app_you_will_make?": "What kind of app you will make?",
				"You_don't_have_Item_Purchase_Code_or_your_Item_Purchase_Code_is_not_valid": "You don't have Item Purchase Code or your Item Purchase Code is not valid",
				"You_don't_have_any_Subscription_Plan": "You don't have any Subscription Plan",
				"You_have_reach_the_limit_for_maximum_apps": "You have reach the limit for maximum apps",
				"rab_saas_site": "Settings",
				"will_send_you_an_email_when_your_apps_are_made": "will send you an email when your apps are made"
			}
		}
	},
	"users": {
		"CFyEmQFR5JOPe13LmjddLdZHRcf2": {
			"language": "gb"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/config/schema.json
// module id = 228
// module chunks = 0